import { render, staticRenderFns } from "./FormOfficeContent.vue?vue&type=template&id=35884369&"
import script from "./FormOfficeContent.vue?vue&type=script&lang=js&"
export * from "./FormOfficeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports